module.exports = __webpack_public_path__ + "img/builder-avatar-stub.c3604bba.svg";